import React, {Component} from 'react';
import i from '../imports';

const messageStyle = {
    fontStyle: "italic",
    fontSize: 16,
    paddingBottom: 10,
    paddingLeft: 10,
    textAlign: "right",
}

const photoStyle = {
    margin: 0,
   // borderRadius: '50% 50%',
   borderRadius: 10,
    width: 'auto',
    height: 180,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    textAlign: "center",
}

const itemStyle = {
    marginRight:32,
    marginLeft:32
    
}

class SouvenirItem extends Component {
    render() {
        let item = this.props.item;
        return (


        <div style={{ marginBottom:45}}>
            <i.Row style={{marginTop: 45}} justify="center" >
                <i.Col align="center">
                    {item.name}
                </i.Col>
            </i.Row>
            <i.Container className="souvenir-item" style={itemStyle}>
                <i.Row>
                    <i.Col md={12} xs={12} align="center" >
                        {/* <div style={Object.assign({
                            backgroundImage: `url('${item.pic}')`
                        }, photoStyle)}></div>
                         */}
                         <div style={{marinBottom: 10, position: 'relative', height: 180, backgroundImage: `url('${item.pic}')`, backgroundSize: 'cover'}} className='card'></div>
                    </i.Col>
                </i.Row>
            </i.Container>
        </div>
        );
    }
}

export default SouvenirItem;